import { useState } from "react";
import { useToast } from "../../../../hooks/use-toast";
import OnPremResourceRequests from "../../ResourceRequests/Tabs/OnPremResourceRequests";
import ResourceRequestFilters from "../../ResourceRequests/ResourceRequestFilters";
import { downloadOnPremRequestReport } from "../../ResourceRequests/Api/resourcerequestapi";
import { myLocalStorage } from "../../../StorageHelper";
import useUserStore from "../../../../services/userStore";

interface ResourceRequestsDeviceDetailsProps {
  computerName?: string;
}

export default function ResourceRequestsDeviceDetails({
  computerName = "",
}: ResourceRequestsDeviceDetailsProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [privilegeFilter, setPrivilegeFilter] = useState("all");
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const { toast } = useToast();
  const latestTenant = myLocalStorage.getItem("latestTenant");
  const tenantName =
    typeof latestTenant === "string"
      ? latestTenant
      : latestTenant?.tenantName || "";
  const { email, role } = useUserStore((state) => state.user);

  const handleReset = () => {
    setStartDate(undefined);
    setEndDate(undefined);
    setStatusFilter("all");
    setPrivilegeFilter("all");
    setSearchTerm("");
  };

  const handleDownloadReport = async () => {
    toast({
      title: "Download Started",
      description: "Endpoints resource requests report is being downloaded...",
    });
    try {
      await downloadOnPremRequestReport(
        "onprem",
        tenantName,
        computerName,
        role,
        startDate ? startDate.toISOString() : "",
        endDate ? endDate.toISOString() : "",
        searchTerm,
        email,
        statusFilter,
        privilegeFilter,
      );
    } catch {
      toast({
        title: "Download Failed",
        description: "Unable to generate the report. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="resource-request-page endpoint-resource-requests">
      <ResourceRequestFilters
        idPrefix="endpoint-resource-request"
        searchTerm={searchTerm}
        statusFilter={statusFilter}
        privilegeFilter={privilegeFilter}
        startDate={startDate}
        endDate={endDate}
        onSearchChange={setSearchTerm}
        onStatusChange={setStatusFilter}
        onPrivilegeChange={setPrivilegeFilter}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        onReset={handleReset}
        onDownloadReport={handleDownloadReport}
        includeCloudStatus={false}
      />
      <div className="resource-request-content">
        <OnPremResourceRequests
          key={privilegeFilter}
          computerName={computerName}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          privilegeFilter={privilegeFilter}
          startDate={startDate}
          endDate={endDate}
          activeTab="onprem"
        />
      </div>
    </div>
  );
}
